<template>
  <el-dialog
      title="用户授权"
      @open="init"
      @close="doClose"
      :destroy-on-close="true"
      :append-to-body="true"
      :visible.sync="visible"
      :modal-append-to-body="true"
      width="680px">
    <div class="auth-save-page">
      <el-form :model="user" label-width="60px" size="small" label-position="right">
        <el-form-item label="姓名:" prop="name">
          <el-input v-model="user.trueName" :disabled="true" placeholder="输入用户姓名,例：xxx" style="width: 40%"></el-input>
        </el-form-item>
        <el-form-item label="角色:" prop="role">
          <template>
            <el-transfer v-model="roleIds" :props="props" :data="roleList" :titles="['所有角色', '已授权角色']"></el-transfer>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="small" @click="doClose()"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button size="small" type="primary" @click="saveUserAuth()"><i class="fa fa-save"></i> 保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fetchAll } from '@/api/system/role'
import { fetchRoleByUserId, saveUserAuth } from '@/api/system/auth'

export default {
  props: {
    echo: null,
    visible: false
  },
  data() {
    return {
      roleIds: [],
      roleList: [],
      user: {},
      props: {
        key: 'id',
        label: 'name'
      }
    }
  },
  methods: {
    init(){
      this.roleTransfer()
      this.fetchEcho()
    },
    roleTransfer() {
      fetchAll().then(resp => {
        this.roleList = resp.data.result
      })
    },
    fetchEcho() {
      if(this.echo){
        fetchRoleByUserId(this.echo.id).then(resp => {
          resp.data.result.forEach(row => {
            this.roleIds.push(row.id)
          })
        })
      }
    },
    saveUserAuth() {
      saveUserAuth(this.user.id, this.roleIds).then(resp => {
        if (resp.status === 200) {
          let user = this.$store.state.user.info
          this.$store.dispatch('generateRoutes', user.roles || [])
          this.$message.success(resp.data.message)
          this.$emit('done', true)
        }
      })
    },
    doClose() {
      this.$emit('done', false)
    }
  }
}
</script>
